import CreateInfoGraphicComponent from "../components/infographic/create/create-infographic.component";
import { useParams } from "react-router-dom";

const CreateInfoGraphic = () => {
    const { id } = useParams(); // Get the dynamic :id parameter

    return (
        <CreateInfoGraphicComponent id={id}></CreateInfoGraphicComponent>
    )

}

export default CreateInfoGraphic;